export default __webpack_public_path__ + "static/juliak-fcff9c9c009fd78b5117f04e59df4cd1.webp";